import { enUS, de } from 'date-fns/locale'

/**
 * Maps i18n language codes to date-fns locale objects
 */
const localeMap = {
  en: enUS,
  de: de,
}

/**
 * Get the date-fns locale object for the current i18n language
 * @param {string} language - The i18n language code (e.g., 'en', 'de')
 * @returns {Locale} The corresponding date-fns locale object
 */
export function getDateLocale(language) {
  return localeMap[language] || localeMap.en
}
